{#if $online && $currentUser && hasRole($currentUser, UserRole.rep)}
  {#if due.customers}
    <Customers on:success={() => synced('customers')} />
  {/if}
  {#if due.products}
    <Products on:success={() => synced('products')} />
  {/if}
  {#if due.deliveryOptions}
    <DeliveryOptions on:success={() => synced('deliveryOptions')} />
  {/if}
  {#if due.categories}
    <Categories on:success={() => synced('categories')} />
  {/if}
  {#if due.categorizations}
    <Categorizations on:success={() => synced('categorizations')} />
  {/if}
{/if}

<script lang="ts">
  import { online, currentUser } from '../stores'
  import { hasRole } from '../users/user'
  import { UserRole } from '../models'
  import Customers from './offline_loader/Customers.svelte'
  import Products from './offline_loader/Products.svelte'
  import DeliveryOptions from './offline_loader/DeliveryOptions.svelte'
  import Categories from './offline_loader/Categories.svelte'
  import Categorizations from './offline_loader/Categorizations.svelte'
  import { markSynced, shouldSync } from './offline_loader/sync'

  const dueModels = () => ({
    customers: shouldSync('customers'),
    products: shouldSync('products'),
    deliveryOptions: shouldSync('deliveryOptions'),
    categories: shouldSync('categories'),
    categorizations: shouldSync('categorizations'),
  })

  let due = {
    customers: false,
    products: false,
    deliveryOptions: false,
    categories: false,
    categorizations: false,
  }

  $: if ($online) due = dueModels()

  const synced = model => {
    markSynced(model)
    due = { ...due, [model]: false }
  }
</script>
